module.exports = __webpack_public_path__ + "static/media/Scann Success_coin_a.11fcb135.mp3";